/* eslint-disable max-len */
import { UnwrapRef } from '@nuxtjs/composition-api';

import { BloczekMarker } from '../../../types/marker/BloczekMarker';
import IMarkersInnerState from '../../../types/markersInnerState';

const getActiveMarker = (markersInnerState: UnwrapRef<IMarkersInnerState<BloczekMarker>>) => markersInnerState.markers?.find((item: BloczekMarker) => item.Id === markersInnerState.activeMarker?.Id);
export default getActiveMarker;
